/**
 * @description Layout-preserving loading shell shown while the HtmlDocument is fetched.
 * Uses the same splash visuals as Loader but reserves page layout space to reduce CLS.
 */
import React from "react";
import { Loader } from "./loader";

export const PageLoadingShell = () => (
  <div className="main-container page-loading-shell" aria-busy="true" aria-live="polite">
    <Loader isActive={true} splash={true} contained={true} />
  </div>
);
